export const metricsSelectDropdown = (all_metric_types: any, gpsDropdowns: any, forceplateDropdowns: any, testingDropdowns: any) => {
    // Deep copy all_metric_types and filter all arrays based on dropdowns
    const filteredMetricTypes = JSON.parse(JSON.stringify(all_metric_types || {}));

    // Create lookup maps for dropdown labels
    const gpsLabelMap = new Map();
    const forceplateLabelMap = new Map();
    const testingLabelMap = new Map();

    // Build GPS label map
    if (gpsDropdowns?.length > 0) {
        gpsDropdowns.forEach((dropdownItem: any) => {
            if (dropdownItem.children) {
                dropdownItem.children.forEach((child: any) => {
                    gpsLabelMap.set(child.key, child.label);
                });
            } else {
                gpsLabelMap.set(dropdownItem.key, dropdownItem.label);
            }
        });
    }

    // Build forceplate label map
    if (forceplateDropdowns?.length > 0) {
        forceplateDropdowns.forEach((dropdownItem: any) => {
            if (dropdownItem.children) {
                dropdownItem.children.forEach((child: any) => {
                    forceplateLabelMap.set(child.key, dropdownItem.label + " - " + child.label);
                });
            } else {
                forceplateLabelMap.set(dropdownItem.key, dropdownItem.label);
            }
        });
    }

    // Build testing label map
    if (testingDropdowns?.length > 0) {
        testingDropdowns.forEach((dropdownItem: any) => {
            if (dropdownItem.children) {
                dropdownItem.children.forEach((child: any) => {
                    testingLabelMap.set(child.key, dropdownItem.label + " - " + child.label);
                });
            } else {
                testingLabelMap.set(dropdownItem.key, dropdownItem.label);
            }
        });
    }

    // Filter GPS metrics based on gpsDropdowns
    if (filteredMetricTypes.gps && gpsDropdowns?.length > 0) {
        const gpsDropdownKeys = new Set();

        // Extract all unique keys from gpsDropdowns (including nested children)
        gpsDropdowns.forEach((dropdownItem: any) => {
            if (dropdownItem.children) {
                dropdownItem.children.forEach((child: any) => {
                    gpsDropdownKeys.add(child.key);
                });
            } else {
                gpsDropdownKeys.add(dropdownItem.key);
            }
        });

        // Filter GPS metrics to only include those in the dropdowns
        filteredMetricTypes.gps = filteredMetricTypes.gps.filter((metric: any) =>
            gpsDropdownKeys.has(metric.unique_identifier)
        );
    }

    // Filter forceplate metrics based on forceplateDropdowns
    if (filteredMetricTypes.forceplate && forceplateDropdowns?.length > 0) {
        const forceplateDropdownKeys = new Set();

        // Extract all unique keys from forceplateDropdowns (including nested children)
        forceplateDropdowns.forEach((dropdownItem: any) => {
            if (dropdownItem.children) {
                dropdownItem.children.forEach((child: any) => {
                    forceplateDropdownKeys.add(child.key);
                });
            } else {
                forceplateDropdownKeys.add(dropdownItem.key);
            }
        });

        // Filter forceplate metrics to only include those in the dropdowns
        filteredMetricTypes.forceplate = filteredMetricTypes.forceplate.filter((metric: any) =>
            forceplateDropdownKeys.has(metric.unique_identifier)
        );
    }

    // Filter testing metrics based on testingDropdowns
    if (filteredMetricTypes.testing && testingDropdowns?.length > 0) {
        const testingDropdownKeys = new Set();

        // Extract all unique keys from testingDropdowns (including nested children)
        testingDropdowns.forEach((dropdownItem: any) => {
            if (dropdownItem.children) {
                dropdownItem.children.forEach((child: any) => {
                    testingDropdownKeys.add(child.key);
                });
            } else {
                testingDropdownKeys.add(dropdownItem.key);
            }
        });

        // Filter testing metrics to only include those in the dropdowns
        filteredMetricTypes.testing = filteredMetricTypes.testing.filter((metric: any) =>
            testingDropdownKeys.has(metric.unique_identifier)
        );
    }

    return {filteredMetricTypes, gpsLabelMap, forceplateLabelMap, testingLabelMap}
}